import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_PAGE_URL } from '../../utils/Routes';

function HomePageHeader() {
  return (
    <header className="grid relative w-full items-center justify-center text-center px-4 pt-12">
      <div className="grid gap-y-8 py-16 md:py-24 lg:py-36">
        <div className="grid h-fit gap-y-2">
          <h1 className="text-2xl md:text-6xl font-bold uppercase">
            Phoenix Headdress
          </h1>
          <p className="text-sm md:text-lg tracking-wide">
            Multifaceted Geometric Magnificence
          </p>
        </div>

        <div>
          <Link
            to={CONTACT_PAGE_URL}
            aria-label="Enquire about the Phoenix Headdress"
            title="Enquire about the Phoenix Headdress"
            className="italic text-sm font-serif hover:text-colour6"
          >
            Enquire Now
          </Link>
        </div>
      </div>
    </header>
  );
}

export default HomePageHeader;
